var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHuaweiLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#svg-public/img/icons/huawei_logo.svg__clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.373 0H5.627C1.507 0 0 1.507 0 5.627v8.746C0 18.493 1.507 20 5.627 20h8.744C18.49 20 20 18.493 20 14.373V5.627C20 1.507 18.493 0 14.373 0z",
  fill: "#C8102E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.96 10.002h.53v2.615h-.53v-1.063H2.761v1.063H2.23v-2.615h.532v1.055h1.197v-1.055zm2.99 1.497c0 .425-.212.652-.595.652-.386 0-.598-.234-.598-.67v-1.478h-.53v1.495c0 .736.408 1.157 1.12 1.157.72 0 1.133-.43 1.133-1.18v-1.474h-.53v1.498zm6.13.3l-.594-1.797h-.432L11.46 11.8l-.578-1.797h-.565l.912 2.614h.439l.595-1.717.594 1.717h.443l.909-2.614h-.55L13.08 11.8zm2.08-.307h.965v-.476h-.965v-.535h1.402v-.477h-1.924v2.612h1.974v-.477H15.16v-.647zm2.084 1.121h.524v-2.611h-.524v2.611zm-8.716-.542l-.238.545h-.542L8.9 10.002h.468l1.148 2.614H9.96l-.236-.545H8.528zm.197-.47h.802l-.401-.936-.401.935zM10 6.673a3.332 3.332 0 01-3.33-3.33h.472A2.863 2.863 0 0010 6.203a2.863 2.863 0 002.859-2.86h.47A3.335 3.335 0 0110 6.673z",
  fill: "#fff"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "svg-public/img/icons/huawei_logo.svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export { SvgHuaweiLogo as ReactComponent };